import { useHookstate } from "@hookstate/core";
import { FLEET_GLOBAL_STATES } from "globalStore/globalStore";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { deviceType } from "../constant";

export const useCarSettingsData = () => {
  const dispatch = useDispatch();
  const { carSettingsDataContainer, selectFleetCarsData } =
    useHookstate(FLEET_GLOBAL_STATES);
  const { siteSettingsData, carProductStatus, carProductData } = useSelector(
    (state) => state.commonReducers
  );

  useEffect(() => {
    let apiCaller =
      selectFleetCarsData.get() && selectFleetCarsData.get().length !== 0
        ? selectFleetCarsData.get().map((item) => {
          dispatch(COMMON_SERVICES.getProductData(item?.GpsiCarId));
        })
        : [];
  }, []);

  useEffect(() => {
    if (carProductStatus === "success") {
      carSettingsDataContainer.set([
        ...carSettingsDataContainer.get(),
        carProductData,
      ]);
    }
  }, [carProductStatus]);

  const guardianMode = {
    normal: 1,
    staging: 2,
    lockdown: 3,
  };

  var distanceUnits = {
    Unknown: 0,
    Yards: 1,
    Metres: 2,
  };

  const convertMileToKM = (mile) => {
    return mile * 1.609344000001;
  };

  const carType = {
    normal: 1,
    marshal: 2,
    handicap: 3,
    bevcart: 4,
    outOfService: 5,
    member: 6,
  };
  const filterByReference = (arr1, arr2) => {
    let res = [];
    res = arr1.filter((el) => {
      return arr2.find((element) => {
        return element.GpsiCarId === el.GpsiCarId;
      });
    });
    return res;
  };

  let checkIfCarCanStage = (car) => {
    return car.AllowedToMove && 
    // PBI 53339 - To exclude FT+ and member cars
    car?.DevType != deviceType.FT2 && 
    !([deviceType.VDU3, deviceType.VDU4].includes(car?.DevType) && car?.CarType === carType.member);
  };

  let isSiteUsingYards = () => {
    return (
      siteSettingsData &&
      siteSettingsData?.DistanceUnits === distanceUnits.Yards
    );
  };

  const carGuardianCapable = function (car) {
    return car?.GuardianCapable !== false;
  };

  const isStagingOrLockMode2 = () => {
    return (
      siteSettingsData?.GuardianCapable && siteSettingsData.GuardianMode > 1
    );
  };

  const isStagingMode = () => {
    return (
      siteSettingsData?.GuardianCapable &&
      siteSettingsData?.GuardianMode === guardianMode.staging
    );
  };

  const isStaged = (car, carSettings) => {
    return isStagingMode() && !(carSettings.AllowedToMove && car.AllowedToMove);
  };

  const isEnabled = (car, carSettings) => {
    if (siteSettingsData.GuardianMode === guardianMode.staging)
      return (
        carSettings.AllowedToMove && carSettings.ATMversion !== car.ATMversion
      );
    else if (siteSettingsData.GuardianMode === guardianMode.lockdown) {
      return carSettings.AllowedToMove;
    } else return carSettings.AllowedToMove;
  };

  const isNormal = () => { };

  const isReleased = (car) => {
    return (
      carGuardianCapable(car) &&
      car.AllowedToMove &&
      !car.HasMoved &&
      isStagingOrLockMode2()
    );
  };

  const isLocked = (car) => {
    return carGuardianCapable(car) && !car.AllowedToMove; // based on client (car) value
  };

  const canEnable = (car) => {
    if (!siteSettingsData.GuardianCapable || car?.CarType === carType.member) {
      return false;
    }
    if (siteSettingsData.GuardianMode === guardianMode.normal) {
      return !car.AllowedToMove;
    }
    if (siteSettingsData.GuardianMode === guardianMode.lockdown) {
      return true;
    }
    //staging mode
    return !car.AllowedToMove;
  };

  const canStage = (car) =>
    isStagingMode() &&
    car.AllowedToMove &&
    car?.CarType !== carType.member &&
    car?.DevType !== deviceType.FT2;

  const getCarsStagedData = (carsFilter) => {
    const result = carsFilter?.filter(
      (thing, index, self) =>
        index === self.findIndex((t) => t?.GpsiCarId === thing.GpsiCarId)
    );

    return result;
  };

  const getCarsEnabledData = (carsFilter) => {
    const result = carsFilter?.filter(
      (thing, index, self) =>
        index === self.findIndex((t) => t?.GpsiCarId === thing.GpsiCarId)
    );

    return result;
  };

  return {
    isNormal,
    isReleased,
    isStaged,
    canEnable,
    canStage,
    isEnabled,
    isSiteUsingYards,
    checkIfCarCanStage,
    getCarsStagedData,
    getCarsEnabledData,
    isStagingMode,
    guardianMode,
    filterByReference,
    convertMileToKM,
    isLocked,
  };
};
